<template>
  <div class="bg-grid">
    <PageTitleVue :key="key"> Inicio </PageTitleVue>

    <main class="min-h-[85vh] flex flex-col items-center">
      <!-- Logo -->
      <div class="mt-2 w-full">
        <Titles 
          class="uppercase font-semibold"
          :w25="true" 
          :left="false" 
          :label="date" 
        />

        <div class="rounded-full w-[34vh] h-[34vh] ml-auto mr-auto">
          <img
            :src="companyLogo"
            alt="Logo"
            class="w-34 md:h-[34vh] md:w-[34vh] mx-auto object-contain mt-1 mb-1 rounded-full bg-[#4b94cd]"
          />
        </div>
      </div>

      <!-- Ações -->
      <div class="w-full text-left">
        <Titles label="Gerencie suas consultas com velocidade">
          Ações rápidas
        </Titles>
      </div>
      <section
        class="mt-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-1 w-full px-6 max-w-5xl justify-center"
      >

        <!-- cadastrar consultas -->
        <CardButton
          @click="navigateTo(SectorForm)"
          :icon="PhStethoscope"
          :title="'cadastrar'"
          :label="'Nova Consulta'"
          :animate="false"
        />

        <!-- listar consultas -->
        <CardButton
          @click="navigateTo(ConsultasList)"
          :icon="PhFolderUser"
          :title="'todas as'"
          :label="'Consultas'"
          :animate="false"
        />

        <CardButton
          @click="navigateTo(MedicosList)"
          :icon="PhAddressBook"
          :title="'listar'"
          :label="'Médicos Disponíveis'"
          :animate="false"
        />
        
        <!-- cadastrar médico -->
        <CardButton
          @click="navigateTo(DoctorForm)"
          :icon="PhAddressBook"
          :title="'cadastrar'"
          :label="'Novo Médico'"
          :animate="false"
        />

      </section>
    </main>
  </div>
</template>

<script setup>
import ConsultasList from '../extinguisher/layout/pages/ConsultasList.vue';
import MedicosList from '../extinguisher/layout/pages/MedicosList.vue';
import SectorForm from '../extinguisher/layout/SectorForm.vue';
import PageTitleVue from '@/components/Titles/PageTitle.vue';
import CardButton from '@/components/Buttons/CardButton.vue';
import Titles from './components/Titles.vue';
import { 
  PhStethoscope,
  PhFolderUser,
  PhAddressBook
} from '@phosphor-icons/vue';
import router from '@/router';
import { dataAso } from '../extinguisher/store';
import { markRaw } from 'vue';
import DoctorForm from '../extinguisher/layout/DoctorForm.vue';
import { computed } from 'vue';
import { storeApp } from '@/store';

// Computed para obter a logo
const companyLogo = require('@/assets/logo/facill-consulta-bg.webp');
const key = computed(() => storeApp.state.loading)

const today = new Date();
const dayNames = [
  "domingo", 
  "segunda-feira", 
  "terça-feira", 
  "quarta-feira", 
  "quinta-feira", 
  "sexta-feira", 
  "sábado"
];
const monthNames = [
  "janeiro", 
  "fevereiro", 
  "março", 
  "abril", 
  "maio", 
  "junho", 
  "julho", 
  "agosto", 
  "setembro", 
  "outubro", 
  "novembro", 
  "dezembro"
];

const date = `${dayNames[today.getDay()]}, ${today.getDate()} de ${monthNames[today.getMonth()]} de ${today.getFullYear()}`;

// Função para navegação
// function navigateTo(route) {
//   router.push({ name: route });
// }
// adaptada
function navigateTo(value) {
  dataAso.dispatch("setComponentActive", markRaw(value));

  router.push({ name: 'extin' });
}
</script>

<style>
.bg-grid {
  width: 100%;
  height: 100%;
  --s: 27px;
  --c: #0000, #28282803 0.5deg 119.5deg, #0000 120deg;
  --g1: conic-gradient(from 60deg at 56.25% calc(425% / 6), var(--c));
  --g2: conic-gradient(from 180deg at 43.75% calc(425% / 6), var(--c));
  --g3: conic-gradient(from -60deg at 50% calc(175% / 12), var(--c));
  background: var(--g1), var(--g1) var(--s) calc(1.73 * var(--s)), var(--g2),
    var(--g2) var(--s) calc(1.73 * var(--s)), var(--g3) var(--s) 0,
    var(--g3) 0 calc(1.73 * var(--s)) #1e1e1e00;
  background-size: calc(2 * var(--s)) calc(3.46 * var(--s));
}

</style>
